import React from "react";
import { Link } from "gatsby";
import tw, { styled } from "twin.macro";

const Container = styled.div`
  ${tw`p-4 bg-white mb-5 rounded`}
`;
const Header = styled.div`
  ${tw`
    uppercase mt-2.5 mb-6 text-sm font-bold text-gray-700
  `}
`;
const LinkContainer = styled.li`
  ${tw`mb-3`}
`;

const StyledLink = styled(Link)`
  ${tw`text-xs text-gray-500 hover:underline`}
  &:hover {
    color: ${(props) => props.color};
  }

  ${({ $isCurrent }) => $isCurrent && tw`pointer-events-none underline`}
  color: ${({ $isCurrent, color }) => ($isCurrent ? color : "inherit")};
`;

const ScheduleHistory = ({ currentPathname, data, color, site }) => {
  const nodes = data.scheduleHistoryPages.nodes;
  return (
    <Container>
      <Header color={color} site={site}>
        Past Schedules
      </Header>
      <ul>
        {nodes.map((node) => {
          const year = node.path.replace("/schedule/", "");
          return (
            <LinkContainer key={node.id}>
              <StyledLink
                to={node.path}
                $isCurrent={currentPathname === node.path}
                color={color}
              >
                {year} Schedule
              </StyledLink>
            </LinkContainer>
          );
        })}
      </ul>
    </Container>
  );
};

export default ScheduleHistory;
